<template>
  <div>
    <!-- 🔙 Back Button -->
    <v-container class="mb-3 flex">
      <v-spacer />
      <v-btn class="btn btn-secondary" @click="goBack">
        ← Back to Consumers
      </v-btn>
    </v-container>

    <!-- Loading -->
    <div v-if="consumer.loading" class="text-center my-4">
      Loading consumer...
    </div>

    <!-- Content -->
    <div v-else>
      <v-container v-if="consumer.data" class="pt-0 pb-3">
        <div class="text-h5 font-weight-bold">
          {{ consumer.data.name }}
        </div>
      </v-container>

      <!-- 🟢 Create on Top -->
      <sale-create
        :default-consumer="consumer.data"
        @upload-success="handleCreated"
      />

      <hr class="my-4">
      <!-- 📋 Index Below -->
      <sale-index ref="saleIndexRef" :default-consumer="consumer.data" />
    </div>
  </div>
</template>

<script>
import { authAxios } from '@/extra-functions/axios.extra'
import { ErrorPopup } from '../../../../../../lib/utils'
import { AxiosError } from 'axios'

export default {
  name: 'ConsumerCashSale',
  components: {
    SaleCreate: () =>
      import('@/views/dashboard/components/sale-inventories/v2/Create.vue'),
    SaleIndex: () =>
      import('@/views/dashboard/components/sale-inventories/v2/Index.vue'),
  },
  data() {
    return {
      consumer: {
        data: null,
        loading: false,
        controller: null,
      },
    }
  },
  created() {
    this.fetchConsumer()
  },
  unmounted() {
    this.consumer.controller?.abort()
  },
  methods: {
    goBack() {
      this.$router.push('/consumers')
    },

    async fetchConsumer() {
      try {
        this.consumer.controller?.abort()
        this.consumer.controller = new AbortController()
        this.consumer.loading = true

        const axios = authAxios()
        const response = await axios.get(
          `/v2/consumers/${this.$route.params.consumer}`,
          {
            signal: this.consumer.controller.signal,
          },
        )

        this.consumer = {
          ...this.consumer,
          data: response.data,
        }
      } catch (e) {
        if (process.env.NODE_ENV === 'development') {
          console.error('Error fetching consumer:', e)
        }

        if (AxiosError(e)) {
          if (e.response?.status === 404) {
            ErrorPopup.fire('Error', 'Consumer not found')
            return
          }

          if (e.response?.status === 500) {
            ErrorPopup.fire(
              'Error',
              'Server error while fetching consumer details',
            )
            return
          }
        }

        ErrorPopup.fire(
          'Error',
          'Oops, something went wrong while fetching consumer details',
        )
      } finally {
        this.consumer.loading = false
      }
    },
    handleCreated() {
      this.$refs.saleIndexRef?.getData()
    },
  },
}
</script>
